"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.string.includes.js");
var _checkerItem = _interopRequireDefault(require("./checker-item"));
var COMPONENT_NAME = 'z-checker';
var _default2 = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('ul', {
      staticClass: "z-checker"
    }, [_vm._t("default", _vm._l(_vm.options, function (option, index) {
      return _c('z-checker-item', {
        key: index,
        attrs: {
          "white-background": _vm.whiteBackground,
          "line-clamp": _vm.lineClamp,
          "option": option,
          "border": _vm.border,
          "outlined": _vm.outlined,
          "width": _vm.width,
          "isBig": _vm.isBig
        }
      });
    }))], 2);
  },
  name: COMPONENT_NAME,
  components: {
    ZCheckerItem: _checkerItem.default
  },
  props: {
    value: [String, Number, Array],
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      default: 'checkbox',
      validator: function validator(val) {
        return ['checkbox', 'radio'].includes(val);
      }
    },
    border: {
      type: String,
      default: 'square' // 可选  round
    },

    outlined: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: Number,
    width: [Number, String],
    lineClamp: [Number, String],
    whiteBackground: Boolean,
    cancelable: Boolean,
    valueKey: {
      type: String,
      default: 'value'
    },
    textKey: {
      type: String,
      default: 'text'
    },
    subTextKey: {
      type: String,
      default: 'subText'
    },
    isBig: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentValue: this.setCurrentValue()
    };
  },
  computed: {
    isRadio: function isRadio() {
      return this.type === 'radio';
    },
    computedMax: function computedMax() {
      return typeof this.max === 'number' ? this.max : this.options.length;
    },
    exclusiveOption: function exclusiveOption() {
      var item = this.options.find(function (item) {
        return item.exclusive;
      });
      return item && item.value;
    }
  },
  watch: {
    value: function value(val) {
      this.setCurrentValue(val);
      this.$emit('change', val);
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    setCurrentValue: function setCurrentValue(val) {
      var _ref;
      if (val === void 0) {
        val = this.value;
      }
      this.currentValue = this.type === 'radio' ? val : Array.isArray(val) ? val : ((_ref = [val]) === null || _ref === void 0 ? void 0 : _ref.filter(function (i) {
        return i;
      })) || [];
      return this.currentValue;
    },
    check: function check(option) {
      if (this.isRadio) {
        this.checkRadio(option);
      } else {
        this.checkCheckbox(option);
      }
    },
    checkRadio: function checkRadio(option) {
      if (this.cancelable && this.currentValue === option[this.valueKey]) {
        this.currentValue = '';
      } else {
        this.currentValue = option[this.valueKey];
      }
    },
    checkCheckbox: function checkCheckbox(option) {
      var _this$currentValue;
      this.currentValue = this.currentValue || []; // 兼容切换tab时currentValue为null的情况
      var value = option[this.valueKey];
      var index = (_this$currentValue = this.currentValue) === null || _this$currentValue === void 0 ? void 0 : _this$currentValue.indexOf(value);
      if (index > -1) {
        var _this$currentValue2;
        if (((_this$currentValue2 = this.currentValue) === null || _this$currentValue2 === void 0 ? void 0 : _this$currentValue2.length) > this.min) {
          var _this$currentValue3;
          (_this$currentValue3 = this.currentValue) === null || _this$currentValue3 === void 0 ? void 0 : _this$currentValue3.splice(index, 1);
        } else {
          this.$emit('no-less', this.currentValue);
        }
      } else {
        var _this$currentValue4, _this$currentValue5;
        if (option.exclusive || (_this$currentValue4 = this.currentValue) !== null && _this$currentValue4 !== void 0 && _this$currentValue4.includes(this.exclusiveOption)) {
          this.currentValue = [];
        }
        if (((_this$currentValue5 = this.currentValue) === null || _this$currentValue5 === void 0 ? void 0 : _this$currentValue5.length) < this.computedMax) {
          var _this$currentValue6;
          (_this$currentValue6 = this.currentValue) === null || _this$currentValue6 === void 0 ? void 0 : _this$currentValue6.push(value);
        } else {
          this.$emit('exceed', this.currentValue);
        }
      }
    }
  }
};
exports.default = _default2;